<template>
  <div class="page-financial-highlights">
    <HeadBanner
       v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <Breadcrumb />

    <HighlightsList
      v-if="_.get(this.$store.state.current_content, 'secondary.HighlightsList.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.HighlightsList.data')"
    />
    <AboutLinkBanner
      v-if="_.get(this.$store.state.current_content, 'secondary.AboutLinkBanner.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.AboutLinkBanner.data[0]')"
    />
    <NewsBlock
      v-if="_.get(this.$store.state.current_content, 'secondary.NewsBlock.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.NewsBlock')"
    />
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import HighlightsList from "@/components/HighlightsList";
import AboutLinkBanner from "@/components/AboutLinkBanner";
import NewsBlock from "@/components/NewsBlock";
import HighlightsTabs from "@/components/HighlightsTabs";


export default {
  components: {
    HeadBanner,
    Breadcrumb,
    HighlightsList,
    AboutLinkBanner,
    NewsBlock,
    HighlightsTabs,
  }
};
</script>